import React, { Suspense, lazy } from 'react';

import { Edit, useRecordContext } from 'react-admin';
import { useFormContext }   from 'react-hook-form';
import { RJSFSchema }       from '@rjsf/utils';
import { JSONSchemaForm } from '../../components/form/json.schema.form';

const ConfigurationEdit = () => {
  const record     = useRecordContext();
  const { setValue } = useFormContext();

  // backend now returns: { formConfig: { schema, uischema } }
  let formConfig = record?.configuration?.configurableSchema?.formConfig;
  let jsonSchema = record?.configuration?.configurableSchema?.jsonSchema;
  let schema: RJSFSchema;

  if (jsonSchema) {
    schema = jsonSchema;
  } else if (formConfig) {
    schema = formConfig.schema;
  } else {
    schema = record?.configuration?.configurableSchema;
  }

  // ALWAYS pass the schema object exactly as you get it
  if (!schema) {
    schema = { type: 'object', properties: {} };
  }

  const uiSchema   = formConfig?.uischema ?? {};   // fallback to {} if absent
  const formData   = record?.configuration?.configurationValues ?? {};


  const handleOnChange = (data: Record<string, any>) => {
    setValue('configuration.configurationValues', data, { shouldDirty: true });
  };

  return (
    <Edit>
      <JSONSchemaForm
        schema={schema}
        uiSchema={uiSchema}
        formData={formData}
        onChange={handleOnChange}
      />
    </Edit>
  );
};

export default ConfigurationEdit;


/*import { Edit, useRecordContext } from "react-admin";
import { useFormContext } from "react-hook-form";

import JSONSchemaForm from "../../components/form/json.schema.form";
import { RJSFSchema, UiSchema } from '@rjsf/utils';

interface ConfigurableSchema {
  schema: RJSFSchema;
  uiSchema: Record<string, any>; // Adjust if you have a UiSchema type
}

function convertFieldsToRJSFSchema(fields: any[]): RJSFSchema {
  const schema: RJSFSchema = {
    type: 'object',
    properties: {},
    required: [] // <-- Add this
  };

  for (const field of fields) {
    let fieldSchema: any = { type: 'string' }; // default fallback

    switch (field.control?.type) {
      case 'text':
        fieldSchema = { type: 'string' };
        if (field.control.validator) {
          fieldSchema.format = field.control.validator;
        }
        break;
      case 'date':
        fieldSchema = { type: 'string', format: 'date' };
        break;
      case 'toggle':
        fieldSchema = { type: 'boolean' };
        break;
      case 'dropdown':
        fieldSchema = {
          type: 'string',
          enum: field.control.values?.map((v: any) => v.id)
        };
        break;
      case 'radio':
        fieldSchema = {
          type: 'string',
          enum: [field.control.value]
        };
        break;
    }

    schema.properties![field.id] = fieldSchema;
    if (!field.optional) {
      schema.required!.push(field.id);
    }
  }

  return schema;
}

const ConfigurationEdit = () => {
  const record = useRecordContext();
  const { setValue } = useFormContext();

  const configurableSchema: ConfigurableSchema = record?.configuration?.configurableSchema;
  const formConfig = (configurableSchema as any)?.formConfig;

  const schema = formConfig?.schema?.fields
    ? convertFieldsToRJSFSchema(formConfig.schema.fields)
    : { type: 'object' as const, properties: {}, required: [] };

  const configurationValues = record?.configuration?.configurationValues || {};

  const handleOnChange = (data: Record<string, any>) => {
    if (data) {
      setValue("configuration.configurationValues", data, { shouldDirty: true });
    }
  };

  return (
    <Edit>
      <JSONSchemaForm
        schema={schema}
        formData={configurationValues}
        uiSchema={formConfig?.uischema}
        onChange={handleOnChange}
      />
    </Edit>
  );
};

export default ConfigurationEdit;
*/
